import { Pipe, PipeTransform } from "@angular/core";
import { orderBy } from 'lodash';

@Pipe({
  name: "orderBy",
  //pure:false  // 오더바이 퓨어 필요하면 따로 만들어 쓸것. 
})
export class OrderByPipe implements PipeTransform {
  transform = orderBy;
}